<!-- @format -->

<article class="substitution-box" [class.multiple-substitutions]="substituteCourseUnits.length > 1">
  @for (courseUnit of substituteCourseUnits; track courseUnit) {
    <sis-study-box
      [level]="level"
      [id]="courseUnit.id"
      [name]="courseUnit.name"
      [code]="courseUnit.code"
      [credits]="courseUnit.credits"
      [attainedCredits]="courseUnit.attainedCredits"
      [gradeId]="courseUnit.gradeId"
      [gradeScaleId]="courseUnit.gradeScaleId"
      (nameClickAction)="nameClickAction.emit(courseUnit.id)"
      [studyState]="courseUnit.studyState !== 'ACTIVE' ? courseUnit.studyState : null">
      <ng-container study-box="notifications">
        @if (courseUnit?.isAttainmentAboutToExpire) {
          <sis-study-notification-box type="info">{{
            "SIS_COMPONENTS.STUDY.EXPIRATION_IMMINENT" | translate: { expiryDate: courseUnit.attainmentExpiryDate | localDateFormat }
          }}</sis-study-notification-box>
        }
        <ng-container
          *ngTemplateOutlet="
            substituteCourseUnits.length === 1 ? substitutionInfo : null;
            context: { courseUnits: [courseUnit] }
          "></ng-container>
        @if (substituteCourseUnits.length > 1) {
          <sis-study-notification-box type="substitution">
            {{ "SIS_COMPONENTS.STUDY.PART_OF_SUBSTITUTION" | translate }}
            <ng-container
              *ngTemplateOutlet="courseUnit.isPartialSubstitute ? creditInfo : null; context: { courseUnits: [courseUnit] }"></ng-container>
          </sis-study-notification-box>
        }
        @if (courseUnit.attainedCredits && showAttainment) {
          <sis-course-unit-attainment-box [courseUnit]="getCourseUnit(courseUnit.id)"></sis-course-unit-attainment-box>
        }
        @if (!courseUnit.attainedCredits && showCompletionMethodSelection) {
          <sis-completion-method-box
            [courseUnit]="getCourseUnit(courseUnit.id)"
            [courseUnitSelection]="courseUnit.courseUnitSelection"></sis-completion-method-box>
        }
        @if (courseUnit.courseUnitSelection?.gradeRaiseAttempt && showCompletionMethodSelection) {
          <sis-course-unit-grade-raise-attempt-box
            [attainedCourseUnit]="getCourseUnit(courseUnit.id)"
            [gradeRaiseAttempt]="courseUnit.courseUnitSelection?.gradeRaiseAttempt"></sis-course-unit-grade-raise-attempt-box>
        }
      </ng-container>
    </sis-study-box>
  }
  <ng-container
    *ngTemplateOutlet="
      substituteCourseUnits.length > 1 ? substitutionInfo : null;
      context: { courseUnits: substituteCourseUnits, plural: true }
    "></ng-container>
  @if (action) {
    <sis-study-action-box
      [action]="action"
      [selected]="selected"
      [inputType]="inputType"
      [actionInputId]="actionInputId"
      [actionInputName]="actionInputName"
      [studyInfo]="studyInfo"
      (actionChange)="actionChange.emit()">
    </sis-study-action-box>
  }
</article>

<ng-template #substitutionInfo let-courseUnits="courseUnits" let-plural="plural">
  <sis-study-notification-box
    type="substitution"
    [useFudisLink]="true"
    [tertiaryButtonText]="
      showCompletionMethodSelection && editSubstitutionAction.observed ? 'SIS_COMPONENTS.STUDY.CHANGE_OR_REMOVE_SUBSTITUTION' : undefined
    "
    (tertiaryClickAction)="editSubstitutionAction.emit()">
    {{ getSelectedSubstitutionKey(plural) | translate }}
    <ng-container
      *ngTemplateOutlet="
        isPartialSubstitute(courseUnits) ? creditInfo : null;
        context: { courseUnits: substituteCourseUnits, plural: plural, isSecondary: true }
      "></ng-container>
  </sis-study-notification-box>
</ng-template>

<ng-template #creditInfo let-courseUnits="courseUnits" let-plural="plural" let-isSecondary="isSecondary">
  @if (isSecondary) {
    <br />
  }
  {{ "SIS_COMPONENTS.STUDY.CREDITS_USED_FOR_SUBSTITUTION" + (plural ? "S" : "") | translate }}
  {{ getSubstituteCredits(courseUnits) | creditRange }}
</ng-template>
